module.exports = [{"product":8502161,"control":"1","case":"1"},{"product":8593291,"control":"1","case":"1"},{"product":8593300,"control":"1","case":"1"},{"product":8593301,"control":"1","case":"1"},{"product":8593385,"control":"1","case":"1"}]


//////////////////
// WEBPACK FOOTER
// ./src/_override/shared/pdp/json/iconProductsList.json
// module id = 1043
// module chunks = 33